import React, { useContext, createContext,useState, useEffect, useRef } from 'react';
import { Table ,Form,Layout, Select, Input, Popconfirm, message,Button } from 'antd';
import './styles.css'
import Axios from 'axios';
import { AuthContext } from '../context/Auth';
import { API_URL } from '../context/constants';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
const { Content } = Layout;
const EditableContext = createContext();



const Tabla = ({rows,setRows,rutas}) => {
    let searchInput;
  const {token}=useContext(AuthContext)
  const [searchText,setSearchText]=useState('');
  const [searchedColumn,setSearchedColumn]=useState('')
  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('')
    // this.setState({ searchText: '' });
  };
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
   
  };
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select());
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });
  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };
  const handleDelete=async (key)=>{
    // console.log(key)
      const dataSource = [...rows];
      // console.table(dataSource);
      const final=dataSource.filter(item=>{
        // console.log(item.id);
        return item.id!==key;
      })
      // console.table(final);
      
      try{
        await Axios.delete(`${API_URL}/profile/${key}`,{
          headers:{
            token
          }
        })
        setRows(final);
        message.success('Usuario eliminado')
      }catch(e){
        message.error('No se ha podido borrar al usuario, intentelo de nuevo');

      }
      

  }
  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
  
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
  
    const save = async e => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({ ...record, ...values });
      } catch (errInfo) {
        console.log('Save failed:', errInfo);
      }
    };
  
    let childNode = children;
    if (editable) {
      childNode = editing ? 
        title==="Ruta"?
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} necesita tener informacion.`,
            },
          ]}
        >
          <Select ref={inputRef} onSelect={save}  onBlur={save}>
            
        {rutas.map(item=><Select.Option key={item.id}value={item.nombreRuta}>{item.nombreRuta}</Select.Option> )}
          </Select>
        
        </Form.Item>
        :
        title==='Estado'?
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} necesita tener informacion.`,
            },
          ]}
        >
          <Select ref={inputRef} onSelect={save}  onBlur={save}>
            <Select.Option value='Alta'  >Alta</Select.Option>
            <Select.Option value='Baja'>Baja</Select.Option>
        {/* {rutas.map(item=><Select.Option key={item.id}value={item.nombreRuta}>{item.nombreRuta}</Select.Option> )} */}
          </Select>
        
        </Form.Item>

        
        
        :<Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} necesita tener informacion.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
        
        
       : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
};

const handleSave =async row => {
    const newData = [...rows];
  
    const index = newData.findIndex(item => row.id === item.id);
    const item = newData[index];

    newData.splice(index, 1, { ...item, ...row });
    setRows(newData)
    const id=newData[index].id
    const data=[...newData]
    if(data[index].ruta!==''){
      const ruta=rutas.filter(item=>data[index].ruta===item.nombreRuta)
      if(ruta.length!==0){
    
        // data[index].ruta=ruta[0].id;
       await Axios.patch(`${API_URL}/profile/${id}`,{...data[index],ruta:ruta[0].id,alta:data[index].alta==='Alta'?true:false},{
          headers:{
            token
          }
        })
      }
      
    }
    else{
     await Axios.patch(`${API_URL}/profile/${id}`,{...data[index],alta:data[index].alta==='Alta'?true:false},{
          headers:{
            token
          }
        })
    }
    

  };
      const components={
          body:{
            row:EditableRow,
            cell: EditableCell,
          }
      }
      const col=[
        {title:"ID",dataIndex:"id",fixed:'left',
         ...getColumnSearchProps('id'),
        },
        {title:"Nombre",dataIndex:"nombre",fixed:'left',editable: true,
        ...getColumnSearchProps('nombre'),
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'nombre',
            title: 'Nombre',
            handleSave: handleSave,
            ...getColumnSearchProps('nombre')
          }),
        },
        {title:"Correo",dataIndex:"correo",
        ...getColumnSearchProps('correo')
      },
        {title:"Fecha de Inscripción",dataIndex:"fechaInscripcion",className:"eliminar"},
        {title:"No de Empleado",dataIndex:"numEmpleado",sorter: (a,b)=> a.numEmpleado.length-b.numEmpleado.length,editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'numEmpleado',
            title: 'No de Empleado',
            handleSave: handleSave,
          }),
        },
        {title:"Teléfono",dataIndex:"telefono",
        // ...getColumnSearchProps('telefono'),
        editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'telefono',
            title: 'Telefono',
            handleSave: handleSave,
            // ...getColumnSearchProps('telefono')
          }),
        },
        {title:"Empresa",dataIndex:"empresa",
        ...getColumnSearchProps('empresa'),
        editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'empresa',
            title: 'Empresa',
            handleSave: handleSave,
          }),
        },
        {title:"Destino",dataIndex:"destino",sorter: (a,b)=> a.destino.length-b.destino.length,editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'destino',
            title: 'Destino',
            handleSave: handleSave,
          }),
        },
        {title:"Tipo de Turno",dataIndex:"tipoTurno",sorter: (a,b)=> a.tipoTurno.length-b.tipoTurno.length,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'tipoTurno',
            title: 'Tipo de Turno',
            handleSave: handleSave,
          }),
        },
        {title:"Tipo de Rotación",dataIndex:"tipoRotacion",sorter: (a,b)=> a.tipoRotacion.length-b.tipoRotacion.length,editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'tipoRotacion',
            title: 'Tipo de Rotación',
            handleSave: handleSave,
          }),
        },
        {title:"Turno",dataIndex:"turno",sorter: (a,b)=> a.turno.length-b.turno.length,editable: true,
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'turno',
            title: 'Turno',
            handleSave: handleSave,
          }),
        },
        {title:'Semana de Referencia',dataIndex:"semanaReferencia",editable: true,sorter: (a,b)=> a.semanaReferencia-b.semanaReferencia,className:"semana_referencia",
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'semanaReferencia',
            title: 'Semana de Referencia',
            handleSave: handleSave,
          }),
        },
        {title:"Dirección",dataIndex:"direccion",editable: true,sorter: (a,b)=> a.direccion.length-b.direccion.length,className:"direccion",
          onCell: record => ({
            record,
            editable: true,
            dataIndex: 'direccion',
            title: 'Dirección',
            handleSave: handleSave,
          }),
        },
        {title:"Polígono Industrial",dataIndex:"polIndustrial",
        ...getColumnSearchProps('polIndustrial'),
        editable:true,
            onCell: record => ({
            record,
            editable: true,
            dataIndex: 'polIndustrial',
            title: 'Polígono Industrial',
            handleSave: handleSave,
          }),
        },
        {title:"Ruta",dataIndex:"ruta",width: 150,
        ...getColumnSearchProps('ruta'),
        editable:true,className:"ruta_header",
            onCell: record => ({
            record,
            editable: true,
            dataIndex: 'ruta',
            title: 'Ruta',
            handleSave: handleSave,
          }),
        
        },
        {title:"Estado",dataIndex:"alta",
        // ...getColumnSearchProps('alta'),
        editable:true,
            onCell: record => ({
            record,
            editable: true,
            dataIndex: 'alta',
            title: 'Estado',
            handleSave: handleSave,
          }),
        },
        {
          title: 'Eliminar Usuario',
          dataIndex: 'operation',
          className:"eliminar",
          render: (text, record) =>
            rows.length >= 1 ? (
              <Popconfirm title="Seguro que lo quiere eliminar" onConfirm={() => handleDelete(record.id)}/*this.handleDelete(record.key)}*/ >
               {/* eslint-disable-next-line */}
                <a >Eliminar</a>
              </Popconfirm>
            ) : null,
        },
    ];
    const data=rows;
    return (
        <Layout >
            <Content  >
                <Table 
                rowClassName={()=>'editable-r'} 
                scroll={{ x: 1500}} 
                bordered 
                components={components}
                 size="small" style={{marginRight:"15px",}} tableLayout="auto" columns={col} dataSource={data}/>

            </Content>
        </Layout>
    )
}
 
export default Tabla;